//Creates tooltip and makes it invisiblae
var div = d3.select(".gia-chart").append("div")
    .attr("class", "tooltip")
    .style("opacity", 0);

//Sets dimensions
var margin = {top: 0, left: 5, bottom: 5, right: 5},
  width = d3.select(".gia-chart").node().clientWidth,
  width = width - margin.left - margin.right,
  mapRatio = .65,
  height = width * mapRatio;

//Tells the map what projection to use
var projection = d3.geo.albersUsa()
  .scale(width *1.25)
  .translate([width / 2, height / 2]);

//Tells the map how to draw the paths from the projection
var path = d3.geo.path()
  .projection(projection);

//Sets the color scale
var color_domain = [300, 450 ,600, 750];
var ext_color_domain = [150, 300, 450 ,600, 750]; 
var color = d3.scale.threshold() 

.domain(color_domain)
.range(['#e0f4f9','#c2e9f2','#a0ddec','#4bc6df','#0095ad']);

//Appened svg to page
var map = d3.select(".gia-chart").append("svg")
  .style('height', height + 'px')
  .style('width', width + 'px');  

//Load the files
queue()
  .defer(d3.json, "data/usmap.json")
  .defer(d3.csv, "data/states.csv")
  .await(ready);

//Moves selection to front
d3.selection.prototype.moveToFront = function() {
  return this.each(function(){
    this.parentNode.appendChild(this);
  });
}; 

//Moves selection to back
d3.selection.prototype.moveToBack = function() { 
  return this.each(function() { 
    var firstChild = this.parentNode.firstChild; 
      if (firstChild) { 
        this.parentNode.insertBefore(this, firstChild); 
      } 
    }); 
  }; 

function ready(error, us, maptemplate) {
  if (error) throw error;  
 
  //Pair data with state id
  var dataByFIPS = {};
  maptemplate.forEach(function(d) { dataByFIPS[d.FIPS] = d.num; });

  //Pair state name with state id
  var stateByFIPS = {};
  maptemplate.forEach(function(d) { stateByFIPS[d.FIPS] = d.state; });

  //Append states
  map.append("g")
    .attr("class", "states")
    .selectAll("path")
    .data(topojson.feature(us, us.objects.states).features)
    .enter().append("path")
    .attr("d", path)
    .style("fill", function(d) { return color (dataByFIPS[d.id]); })

    //Hovers
    .on("mouseover", function(d) {
      var sel = d3.select(this);
        sel.moveToFront();
      d3.select(this)
        .transition().duration(300).style({'opacity': 1, 'stroke': '#333333', 'stroke-width': 1.5});
      div.transition().duration(300)
        .style("opacity", 1)
      div.text(stateByFIPS[d.id] + "'s imprisonment rate is " + dataByFIPS[d.id] + " per 100,000 US residents");
    })

    .on("mouseout", function() {
      var sel = d3.select(this);
        sel.moveToBack();
      d3.select(this)
        .transition().duration(300).style({'opacity': 1, 'stroke': 'white', 'stroke-width': 1});
      div.transition().duration(300)
        .style("opacity", 0);
    })    

  //RESPONSIVENESS
  d3.select(window).on('resize', resize);

  function resize() {

    var w = d3.select(".gia-chart").node().clientWidth;

    //Adjust things when the window size changes
    width = w - margin.left - margin.right;
    height = width * mapRatio;
    
    //Update projection
    var newProjection = d3.geo.albersUsa()
      .scale(width*1.25)
      .translate([width / 2, height / 2]);

    //Update path
    path = d3.geo.path()
      .projection(newProjection);    

    //Resize the map container
    map
      .style('width', width + 'px')
      .style('height', height + 'px');

    //Resize the map
    map.selectAll("path").attr('d', path);

    //Replace FL label
    map.selectAll(".FL-label")
      .attr("x", width/1.25)
      .attr("y", (width * mapRatio)/1.25);

    map.selectAll(".FL-tspan-state")
      .attr("x", width/1.22)
      .attr("y", (width * mapRatio)/1.25); 

    map.selectAll(".FL-tspan-num")
      .attr("x", width/1.22)
      .attr("y", (width * mapRatio)/1.25);    

    //Replace NV label
    map.selectAll(".NV-label")
      .attr("x", width/6.9)
      .attr("y", (width * mapRatio)/2.475);

    map.selectAll(".NV-tspan-state")
      .attr("x", width/6.9)
      .attr("y", (width * mapRatio)/2.475); 

    map.selectAll(".NV-tspan-num")
      .attr("x", width/6.9)
      .attr("y", (width * mapRatio)/2.475);       

    //Replace AZ label
    map.selectAll(".AZ-label")
      .attr("x", width/4.75)
      .attr("y", (width * mapRatio)/1.675);

    map.selectAll(".AZ-tspan-state")
      .attr("x", width/4.75)
      .attr("y", (width * mapRatio)/1.675); 

    map.selectAll(".AZ-tspan-num")
      .attr("x", width/4.75)
      .attr("y", (width * mapRatio)/1.675);  
  }
}